import { useEffect, useState } from "react";

type ThemeMode = "light" | "dark";

const STORAGE_KEY = "inspira-theme-mode";

function applyTheme(theme: ThemeMode) {
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  root.style.colorScheme = theme === "dark" ? "dark" : "light";
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState<ThemeMode>("light");

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    const initialTheme: ThemeMode = stored === "dark" ? "dark" : "light";
    setTheme(initialTheme);
    applyTheme(initialTheme);
  }, []);

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <button
      type="button"
      aria-label={theme === "dark" ? "Ativar modo claro" : "Ativar modo escuro"}
      title={theme === "dark" ? "Ativar modo claro" : "Ativar modo escuro"}
      onClick={() => setTheme((prev) => (prev === "dark" ? "light" : "dark"))}
      className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-all duration-200"
      style={{
        background: 'var(--badge-bg)',
        border: '1px solid var(--border-soft)',
        color: 'var(--earth-strong)',
      }}
    >
      <i className={theme === "dark" ? "ri-sun-line" : "ri-moon-line"} aria-hidden="true" style={{ fontSize: 16 }} />
    </button>
  );
}

